/* svnty-rail-nav.js: THE RAIL'S EDGE AND ITS HAND (P20-2; the file keeps its name for the layout and for SVNTY.railNav.place()).
 * THE ARROWS ARE GONE (P19-14, the owner: "kill this everywhere"). A row says it scrolls the way the phone's row does: THE CUT
 * CARD. From 750 px a rail in the page runs past the page's margin to the window's edge, so the next card is cut by the edge of
 * the screen; the cards keep their size and the first card keeps its place (the rail's own padding holds it on the page's
 * margin, and the snap rests there). On its start side the rail runs to the window's edge too when nothing stands beside it, so
 * a card that scrolls away leaves under the screen's edge, as on the phone. Only the WINDOW cuts a card: a rail inside a box that
 * clips its content (a card, a panel, a sheet) keeps that box. This script only measures the two distances and writes them on
 * the rail (--rail-cut-r, --rail-cut-l, data-cut); assets/svnty-similar.css does the rest.
 * THE HAND: with a mouse a rail is dragged by the hand (no arrow to press): press, pull, let go; the rail comes to rest on the
 * nearest card, carried by the hand's speed by one view at most; a pull is never a click. Touch and trackpads keep their own scroll. */
(function () {
  'use strict';
  var root = document.documentElement, wide = window.matchMedia('(min-width: 750px)'), queued = false, seen = [];
  var RO = window.ResizeObserver ? new ResizeObserver(ask) : null;
  function inPage(rail) { return !!rail.closest('#MainContent') && !rail.closest('dialog, details-modal, [role="dialog"], .drawer, menu-drawer'); }
  /* a rail inside a box that clips its content (a card, a panel) keeps that box: only the window cuts a card */
  function boxed(rail) {
    var a = rail.parentNode, cs;
    for (a = a && a.parentNode; a && a !== document.body; a = a.parentNode) {
      cs = getComputedStyle(a); if (cs.overflowX !== 'visible' || cs.position === 'fixed') return true;
    }
    return false;
  }
  function cut(rail) {
    var row = rail.parentNode;
    if (!row || !wide.matches || !row.getClientRects().length || !inPage(rail) || boxed(rail)) { if (rail.hasAttribute('data-cut')) { rail.removeAttribute('data-cut'); rail.style.removeProperty('--rail-cut-r'); rail.style.removeProperty('--rail-cut-l'); } return; }
    var box = row.getBoundingClientRect(), vw = root.clientWidth, first = true, k;
    for (k = rail.previousElementSibling; k; k = k.previousElementSibling) if (k.getClientRects().length) first = false;
    /* a side runs to the edge only when nothing stands beside the row on that side (a row in a half of the page keeps its half) */
    var r = box.right >= vw * 0.75 ? Math.max(0, Math.round(vw - box.right)) : 0, l = first && box.left <= vw * 0.25 ? Math.max(0, Math.round(box.left)) : 0;
    var mark = (r > 7 ? 'r' : '') + (l > 7 ? ' l' : '');
    if (rail.getAttribute('data-cut') === mark.trim() && rail.style.getPropertyValue('--rail-cut-r') === r + 'px' && rail.style.getPropertyValue('--rail-cut-l') === l + 'px') return;
    rail.style.setProperty('--rail-cut-r', r + 'px'); rail.style.setProperty('--rail-cut-l', l + 'px'); rail.setAttribute('data-cut', mark.trim());
  }
  function hand(rail) {
    var s = null;
    function rest() {
      var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0, items = rail.children, i, best = rail.scrollLeft, d = Infinity, x, max = rail.scrollWidth - rail.clientWidth;
      for (i = 0; i < items.length; i++) { if (!items[i].offsetWidth) continue; x = Math.min(max, Math.max(0, items[i].offsetLeft - pad)); if (Math.abs(x - s.aim) < d) { d = Math.abs(x - s.aim); best = x; } }
      return best;
    }
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || rail.scrollWidth <= rail.clientWidth + 1) return;
      s = { x: e.clientX, left: rail.scrollLeft, id: e.pointerId, moved: false, t: e.timeStamp, lastX: e.clientX, v: 0, aim: 0 };
    });
    rail.addEventListener('pointermove', function (e) {
      if (!s || e.pointerId !== s.id) return;
      var dx = e.clientX - s.x;
      if (!s.moved) { if (Math.abs(dx) < 6) return; s.moved = true; rail.classList.add('is-pulled'); try { rail.setPointerCapture(s.id); } catch (x) { /* the pointer left: the pull ends on its own */ } }
      var dt = e.timeStamp - s.t; if (dt > 0) { s.v = 0.7 * s.v + 0.3 * ((e.clientX - s.lastX) / dt); s.t = e.timeStamp; s.lastX = e.clientX; }
      rail.scrollLeft = s.left - dx;
    });
    function end(e) {
      if (!s || (e && e.pointerId !== s.id)) return;
      var was = s;
      if (!was.moved) { s = null; return; }
      var owe = was.v * 180, view = rail.parentNode ? rail.parentNode.clientWidth : rail.clientWidth;   /* what the hand's speed still owes the rail, one view at most */
      was.aim = rail.scrollLeft - Math.max(-view, Math.min(view, owe));
      var to = rest(); s = null;
      rail.scrollTo({ left: to, behavior: 'smooth' });
      var done = function () { rail.classList.remove('is-pulled'); rail.removeEventListener('scrollend', done); };
      if ('onscrollend' in window) rail.addEventListener('scrollend', done);
      setTimeout(done, 700);
    }
    rail.addEventListener('pointerup', end); rail.addEventListener('pointercancel', end);
    /* a pull is never a click, and a card's picture is never dragged away as an image */
    rail.addEventListener('click', function (e) { if (rail.classList.contains('is-pulled')) { e.preventDefault(); e.stopPropagation(); } }, true);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function all() {
    queued = false;
    var rails = document.querySelectorAll('[data-svnty-rail]'), i, rail;
    for (i = 0; i < rails.length; i++) {
      rail = rails[i];
      if (seen.indexOf(rail) < 0) { seen.push(rail); hand(rail); if (RO && rail.parentNode) RO.observe(rail.parentNode); }
      cut(rail);
    }
  }
  function ask() { if (queued) return; queued = true; requestAnimationFrame(all); }
  window.SVNTY = window.SVNTY || {}; window.SVNTY.railNav = { place: ask };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ask); else ask();
  window.addEventListener('load', ask); window.addEventListener('resize', ask, { passive: true });
  if (wide.addEventListener) wide.addEventListener('change', ask);
  if (window.MutationObserver) new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { ask(); return; } }).observe(document.documentElement, { childList: true, subtree: true });
})();
